import { LOCALES } from '../../../../../../constants/locales';
import { LABELS } from '../../../../../../constants/subtitle-labels';

import de from './Animated_Gifs_de-DE.vtt';
import es from './Animated_Gifs_es.vtt';
import fr from './Animated_Gifs_fr-FR.vtt';
import it from './Animated_Gifs_it-IT.vtt';
import nl from './Animated_Gifs_nl-NL.vtt';
import pt from './Animated_Gifs_pt-BR.vtt';
import en from './Animated_Gifs_en-US.vtt';

export default [{
    src: de,
    label: LABELS[LOCALES.DE],
    srcLang: LOCALES.DE
}, {
    src: es,
    label: LABELS[LOCALES.ES],
    srcLang: LOCALES.ES
}, {
    src: fr,
    label: LABELS[LOCALES.FR],
    srcLang: LOCALES.FR
}, {
    src: it,
    label: LABELS[LOCALES.IT],
    srcLang: LOCALES.IT
}, {
    src: nl,
    label: LABELS[LOCALES.NL],
    srcLang: LOCALES.NL
}, {
    src: pt,
    label: LABELS[LOCALES.PT],
    srcLang: LOCALES.PT
}, {
    src: en,
    label: LABELS[LOCALES.EN],
    srcLang: LOCALES.EN
}];
